import { render, staticRenderFns } from "./reports-list.vue?vue&type=template&id=6fb1c5be"
import script from "./reports-list.vue?vue&type=script&lang=js"
export * from "./reports-list.vue?vue&type=script&lang=js"
import style0 from "./reports-list.vue?vue&type=style&index=0&id=6fb1c5be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports